import { Injectable } from "@angular/core";
import { ILeadTemplate } from '../model/leadtemplate.interface';
import { BehaviorSubject } from 'rxjs';
import { ICalendarTemplate } from '../model/calendartemplate.interface';
import * as templates from '../../assets/json/templates.json';

/**
 * The templates are compiled into the bundle rather than fetched: the file only ever changes with a
 * release, and a fetch that failed left ready false for good - the Followup and Meeting screens stayed
 * on their skeleton for a user whose browser got something other than JSON for it (#372).
 */
@Injectable()
export class SettingsRepository {
    public leadTemplates: ILeadTemplate[] = templates.leads;
    public calendarTemplates: ICalendarTemplate[] = templates.calendar;
    public ready: BehaviorSubject<boolean> = new BehaviorSubject(true);
}
